
























import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {WarehouseStore} from "@/modules/warehouses/store";
import WarehouseTable from "@/modules/warehouses/shared/components/WarehouseTable/index.vue";
import {PickingListStore} from "@/modules/pickinglists";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";

@Component({
    name: "PickingListDetail",
    components: {WarehouseTable}
})
export default class extends mixins(CommonMixin) {
    @Prop({ required: true, type: Number }) readonly id!: number;

    get warehouses() {
        return WarehouseStore.ids.map((id: number) => WarehouseStore.data[id]);
    }

    get pickingList() {
        return PickingListStore.data[this.id];
    }
}
